export { default } from './confirmationFooter';